import { api } from "@/lib/api-client";
import type { SiteSettings, SiteSettingsForm } from "./types";

export function toSiteSettingsForm(settings: SiteSettings): SiteSettingsForm {
  return {
    siteName: settings.siteName,
    siteTagline: settings.tagline ?? "",
    logoUrl: settings.logoUrl ?? "",
    faviconUrl: settings.faviconUrl ?? "",
    homepageHeadline: settings.heroHeading ?? "",
    homepageSubheadline: settings.heroSubheading ?? "",
    contactEmail: settings.contactEmail ?? "",
    discordUrl: settings.discordUrl ?? "",
    maintenanceMode: settings.maintenanceMode,
    maintenanceMessage: settings.maintenanceMessage ?? "",
    maintenanceEstimatedReturn: settings.maintenanceEstimatedReturn ?? "",
    maintenanceAllowOwnerPreview: settings.maintenanceAllowOwnerPreview,
    maintenanceAllowDeveloperPreview: settings.maintenanceAllowDeveloperPreview,
    seoTitle: settings.seoTitle ?? "",
    seoDescription: settings.metaDescription ?? "",
    seoKeywords: settings.seoKeywords ?? "",
    ogTitle: settings.ogTitle ?? "",
    ogDescription: settings.ogDescription ?? "",
    ogImage: settings.ogImage ?? "",
    canonicalUrl: settings.canonicalUrl ?? "",
    robotsIndex: settings.robotsIndex,
    robotsFollow: settings.robotsFollow,
  };
}

export function toSiteSettingsPayload(input: SiteSettingsForm, includeMaintenanceMode: boolean) {
  return {
    siteName: input.siteName,
    tagline: input.siteTagline || null,
    logoUrl: input.logoUrl || null,
    faviconUrl: input.faviconUrl || null,
    heroHeading: input.homepageHeadline || null,
    heroSubheading: input.homepageSubheadline || null,
    contactEmail: input.contactEmail || null,
    discordUrl: input.discordUrl || null,
    seoTitle: input.seoTitle || null,
    metaDescription: input.seoDescription || null,
    seoKeywords: input.seoKeywords || null,
    ogTitle: input.ogTitle || null,
    ogDescription: input.ogDescription || null,
    ogImage: input.ogImage || null,
    canonicalUrl: input.canonicalUrl || null,
    robotsIndex: input.robotsIndex,
    robotsFollow: input.robotsFollow,
    ...(includeMaintenanceMode
      ? {
          maintenanceMode: input.maintenanceMode,
          maintenanceMessage: input.maintenanceMessage || null,
          maintenanceEstimatedReturn: input.maintenanceEstimatedReturn || null,
          maintenanceAllowOwnerPreview: input.maintenanceAllowOwnerPreview,
          maintenanceAllowDeveloperPreview: input.maintenanceAllowDeveloperPreview,
        }
      : {}),
  };
}

export const siteSettingsApi = {
  get: () => api.get<SiteSettings>("/site-settings"),
  update: (input: SiteSettingsForm, includeMaintenanceMode: boolean) =>
    api.patch<SiteSettings>("/site-settings", toSiteSettingsPayload(input, includeMaintenanceMode)),
};
